(function () {
  'use strict';

  var BATCH = 5;
  var VERASION = 'https://cdn.shopify.com/s/files/1/0646/3268/4615/files/16.png?v=1778917699';
  var TYPES = ['season', 'wine', 'occasion', 'meal', 'dietary', 'ingredient'];
  var ATTRS = {
    season: 'seasons',
    wine: 'wines',
    occasion: 'occasions',
    meal: 'meals',
    dietary: 'dietary',
    ingredient: 'ingredients'
  };

  function norm(value) {
    return String(value == null ? '' : value)
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[’‘]/g, "'")
      .replace(/\s+/g, ' ');
  }

  function canonicalWine(value) {
    var key = norm(value).replace(/_/g, ' ');
    if (key.indexOf('albarino') !== -1) return 'albarino';
    if (key.indexOf('chardonnay') !== -1) return 'chardonnay';
    if (key.indexOf('pinot gris') !== -1 || key.indexOf('pinot-gris') !== -1) return 'pinot-gris';
    if (key.indexOf('amphora blanco') !== -1 || key === 'blanco' || key.indexOf(' blanco') !== -1) return 'blanco';
    if (key.indexOf('pinot noir') !== -1) return 'pinot-noir';
    if (key.indexOf('amphora gsm') !== -1 || key === 'gsm' || key.indexOf('trilog') !== -1) return 'gsm';
    if (key.indexOf('tempranillo') !== -1) return 'tempranillo';
    if (key.indexOf('syrah') !== -1 || key.indexOf('shiraz') !== -1 || key.indexOf('syrha') !== -1) return 'syrah';
    if (key === 'rose' || key.indexOf(' rose') !== -1 || key.indexOf('rose ') !== -1) return 'rose';
    return key.replace(/\s+/g, '-');
  }

  function canonical(type, value) {
    return type === 'wine' ? canonicalWine(value) : norm(value);
  }

  function unique(values) {
    return values.filter(function (value, index, list) {
      return value && list.indexOf(value) === index;
    });
  }

  function replaceText(root, pattern, value) {
    if (!root) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      if (!node.parentElement || /^(SCRIPT|STYLE|NOSCRIPT)$/.test(node.parentElement.tagName)) continue;
      node.nodeValue = node.nodeValue.replace(pattern, value);
    }
  }

  function generalFixes() {
    replaceText(document.getElementById('MainContent'), /gravelly inclines and spare/gi, 'gravelly incline and sparse');

    document.querySelectorAll('img[alt="Veraison - grapes changing colour"]').forEach(function (image) {
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src = VERASION;
    });

    var first = document.querySelector('.wc-contact-page-form input[name="contact[first_name]"]');
    var last = document.querySelector('.wc-contact-page-form input[name="contact[last_name]"]');
    if (first) {
      first.placeholder = 'First name';
      first.autocomplete = 'given-name';
    }
    if (last) {
      last.placeholder = 'Last name';
      last.autocomplete = 'family-name';
    }
  }

  function recipeFixes() {
    var oldWrap = document.getElementById('ri-wrap');
    if (!oldWrap || oldWrap.dataset.wcMetafieldRecipeFilter === 'true') return;

    var wrap = oldWrap.cloneNode(true);
    wrap.dataset.wcMetafieldRecipeFilter = 'true';
    oldWrap.replaceWith(wrap);

    var grid = wrap.querySelector('#ri-grid');
    if (!grid) return;

    var cards = Array.prototype.slice.call(grid.querySelectorAll('.ri-card'));
    var selected = {
      season: [],
      wine: [],
      occasion: [],
      meal: [],
      dietary: [],
      ingredient: []
    };
    var letters = [];
    var limit = BATCH;
    var latest = wrap.querySelector('#ri-latest-section');
    var noResults = wrap.querySelector('#ri-no-results');
    var activeBar = wrap.querySelector('#ri-active-bar');
    var activeLabel = wrap.querySelector('#ri-active-label-value');
    var ingredientList = wrap.querySelector('#ri-ing-list');
    var ingredientEmpty = wrap.querySelector('#ri-ing-empty');
    var clear = wrap.querySelector('#ri-clear-btn');
    var seasonalLatest = false;

    function values(card, type) {
      return unique((card.getAttribute('data-' + ATTRS[type]) || '')
        .split('|')
        .map(function (item) { return canonical(type, item); })
        .filter(Boolean));
    }

    function isSelected(type, value) {
      var target = canonical(type, value);
      return selected[type].some(function (item) {
        return canonical(type, item) === target;
      });
    }

    function toggle(type, value) {
      var target = canonical(type, value);
      if (!target || !selected[type]) return;
      selected[type] = isSelected(type, target)
        ? selected[type].filter(function (item) { return canonical(type, item) !== target; })
        : selected[type].concat([value]);
    }

    function filtering() {
      return TYPES.some(function (type) { return selected[type].length > 0; });
    }

    function matches(card, type) {
      if (!selected[type].length) return true;
      var list = values(card, type);
      return selected[type].some(function (choice) {
        var target = canonical(type, choice);
        if (type === 'dietary') {
          return list.indexOf(target) !== -1 ||
            list.indexOf(target + ' option') !== -1 ||
            list.indexOf(target + ' options') !== -1;
        }
        return list.indexOf(target) !== -1;
      });
    }

    function label(type) {
      return {
        season: 'Season',
        wine: 'Wine',
        occasion: 'Occasion',
        meal: 'Meal',
        dietary: 'Dietary',
        ingredient: 'Ingredient'
      }[type];
    }

    function display(type, value) {
      var buttons = Array.prototype.slice.call(
        wrap.querySelectorAll('[data-filter-type="' + type + '"][data-filter-value]')
      );
      var button = buttons.find(function (item) {
        return canonical(type, item.dataset.filterValue) === canonical(type, value);
      });
      return button ? button.textContent.trim() : String(value).trim();
    }

    function updateControls() {
      wrap.querySelectorAll('[data-filter-type][data-filter-value]').forEach(function (button) {
        var active = button.dataset.filterType === 'letter'
          ? letters.indexOf(String(button.dataset.filterValue).toUpperCase()) !== -1
          : isSelected(button.dataset.filterType, button.dataset.filterValue);

        button.classList.toggle('ri-filter-active', active);
        button.classList.toggle('ri-pill--active', active);
        button.classList.toggle('ri-alpha-btn--active', active);
        button.classList.toggle('ri-ing-tag--active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      if (!ingredientList) return;
      var shown = 0;
      ingredientList.querySelectorAll('.ri-ing-tag[data-ingredient-letter]').forEach(function (button) {
        button.hidden = letters.indexOf(String(button.dataset.ingredientLetter).toUpperCase()) === -1;
        if (!button.hidden) shown += 1;
      });
      if (ingredientEmpty) ingredientEmpty.hidden = !letters.length || shown > 0;
    }

    function updateActiveBar() {
      if (!activeBar || !activeLabel) return;
      activeLabel.innerHTML = '';
      if (!filtering()) {
        activeBar.hidden = true;
        return;
      }

      TYPES.forEach(function (type) {
        selected[type].forEach(function (value) {
          var chip = document.createElement('span');
          chip.className = 'ri-active-filter-chip';

          var category = document.createElement('span');
          category.className = 'ri-active-filter-category';
          category.textContent = label(type) + ':';

          var shownValue = document.createElement('span');
          shownValue.className = 'ri-active-filter-value';
          shownValue.textContent = display(type, value);

          var remove = document.createElement('button');
          remove.type = 'button';
          remove.className = 'ri-remove-filter';
          remove.textContent = '×';
          remove.dataset.removeFilterType = type;
          remove.dataset.removeFilterValue = value;
          remove.setAttribute('aria-label', 'Remove ' + display(type, value) + ' filter');

          chip.appendChild(category);
          chip.appendChild(shownValue);
          chip.appendChild(remove);
          activeLabel.appendChild(chip);
        });
      });

      activeBar.hidden = false;
    }

    function writeUrl() {
      var params = new URLSearchParams(window.location.search);
      Array.from(params.keys()).forEach(function (key) {
        if (key.indexOf('filter_') === 0 ||
            ['ingredient_letter', 'filter_type', 'filter_value', 'q'].indexOf(key) !== -1) {
          params.delete(key);
        }
      });

      TYPES.forEach(function (type) {
        selected[type].forEach(function (value) {
          params.append('filter_' + type, display(type, value));
        });
      });
      letters.forEach(function (letter) { params.append('ingredient_letter', letter); });

      var query = params.toString();
      history.replaceState({}, '', location.pathname + (query ? '?' + query : '') + location.hash);
    }

    function getShowMoreButton() {
      var button = wrap.querySelector('[data-ri-show-more]');
      if (button) return button;

      button = document.createElement('button');
      button.type = 'button';
      button.className = 'ri-show-more';
      button.dataset.riShowMore = 'true';
      button.setAttribute('aria-controls', 'ri-grid');
      grid.insertAdjacentElement('afterend', button);
      return button;
    }

    var more = getShowMoreButton();

    function updateCards() {
      var active = filtering();
      var matched = cards.filter(function (card) {
        return !active || TYPES.every(function (type) { return matches(card, type); });
      });

      cards.forEach(function (card) {
        var index = matched.indexOf(card);
        var match = index !== -1;
        var show = match && index < limit;
        card.hidden = !show;
        card.classList.toggle('ri-card--filtered-out', !match);
        card.classList.toggle('ri-card--batch-hidden', match && !show);
        card.setAttribute('aria-hidden', show ? 'false' : 'true');
      });

      if (latest) {
        var hideLatest = active || !seasonalLatest;
        latest.hidden = hideLatest;
        latest.classList.toggle('ri-latest-section--filtered-out', hideLatest);
      }

      if (noResults) {
        var none = active && matched.length === 0;
        noResults.hidden = !none;
        noResults.classList.toggle('ri-no-results--visible', none);
      }

      var remaining = Math.max(0, matched.length - limit);
      more.hidden = remaining === 0;
      if (remaining) {
        var count = Math.min(BATCH, remaining);
        more.textContent = 'Show ' + count + ' more ' + (count === 1 ? 'recipe' : 'recipes');
      }
    }

    function meta(card, wanted) {
      var rows = Array.prototype.slice.call(card.querySelectorAll('.ri-meta-row'));
      var row = rows.find(function (item) {
        var heading = item.querySelector('.ri-meta-label');
        return heading && norm(heading.textContent) === norm(wanted);
      });
      var value = row && row.querySelector('.ri-meta-value');
      return value ? value.textContent.trim() : '';
    }

    function latestSeasonalRecipe() {
      if (!latest) return;
      var seasonNode = wrap.querySelector('.ri-season-title');
      if (!seasonNode) return;

      var season = norm(seasonNode.textContent);
      var source = cards.find(function (card) {
        return values(card, 'season').indexOf(season) !== -1;
      });

      if (!source) {
        seasonalLatest = false;
        latest.hidden = true;
        return;
      }

      var sourceLink = source.querySelector('.ri-card-title a');
      var targetLink = latest.querySelector('.ri-latest-card');
      var title = sourceLink ? sourceLink.textContent.trim() : '';
      var titleNode = latest.querySelector('.ri-latest-title');
      if (sourceLink && targetLink) {
        targetLink.href = sourceLink.href;
        targetLink.setAttribute('aria-label', 'View latest ' + season + ' recipe: ' + title);
      }
      if (titleNode) titleNode.textContent = title;

      var excerptNode = latest.querySelector('.ri-latest-excerpt');
      var excerptSource = source.querySelector('.ri-card-excerpt');
      var excerpt = excerptSource ? excerptSource.textContent : (source.dataset.excerpt || '');
      if (excerptNode) excerptNode.textContent = excerpt.replace(/\s+/g, ' ').trim().slice(0, 220);

      var sourceImage = source.querySelector('.ri-card-img-wrap img');
      var imageWrap = latest.querySelector('.ri-latest-img');
      if (sourceImage && imageWrap) {
        imageWrap.innerHTML = '';
        imageWrap.appendChild(sourceImage.cloneNode(true));
        imageWrap.hidden = false;
      }

      var pair = meta(source, 'Pairs with');
      var pairNode = latest.querySelector('.ri-latest-wine');
      if (pairNode) {
        pairNode.innerHTML = '<span class="ri-meta-label">Pairs with</span> ';
        pairNode.appendChild(document.createTextNode(pair));
        pairNode.hidden = !pair;
      }

      seasonalLatest = true;
    }

    function refresh(reset) {
      if (reset) limit = BATCH;
      updateControls();
      updateActiveBar();
      updateCards();
      writeUrl();
      wrap.dataset.recipeFilterStatus = 'ready';
    }

    cards.forEach(function (card) {
      card.hidden = false;
      card.classList.remove('ri-card--filtered-out');
    });

    var params = new URLSearchParams(location.search);
    TYPES.forEach(function (type) {
      params.getAll('filter_' + type).forEach(function (value) {
        if (!isSelected(type, value)) selected[type].push(value);
      });
    });
    params.getAll('ingredient_letter').forEach(function (letter) {
      var upper = String(letter).toUpperCase();
      if (letters.indexOf(upper) === -1) letters.push(upper);
    });

    var oldType = params.get('filter_type');
    var oldValue = params.get('filter_value');
    if (oldType === 'letter' && oldValue) {
      letters.push(String(oldValue).toUpperCase());
    } else if (selected[oldType] && oldValue) {
      selected[oldType].push(oldValue);
    }

    wrap.addEventListener('click', function (event) {
      var button = event.target.closest(
        '[data-ri-show-more], [data-remove-filter-type], [data-filter-type][data-filter-value]'
      );
      if (!button) return;

      if (button.dataset.riShowMore) {
        limit += BATCH;
        updateCards();
        return;
      }

      if (button.dataset.removeFilterType) {
        toggle(button.dataset.removeFilterType, button.dataset.removeFilterValue);
        refresh(true);
        return;
      }

      var type = button.dataset.filterType;
      var value = button.dataset.filterValue;
      if (type === 'letter') {
        var letter = String(value).toUpperCase();
        var index = letters.indexOf(letter);
        if (index === -1) letters.push(letter);
        else letters.splice(index, 1);
        updateControls();
        writeUrl();
        return;
      }

      toggle(type, value);
      refresh(true);
    });

    if (clear) {
      clear.addEventListener('click', function () {
        TYPES.forEach(function (type) { selected[type] = []; });
        letters = [];
        refresh(true);
      });
    }

    replaceText(wrap, /syrha\/shiraz/gi, 'Syrah/Shiraz');
    latestSeasonalRecipe();
    refresh(true);
  }

  function run() {
    generalFixes();
    recipeFixes();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
  document.addEventListener('shopify:section:load', run);
})();